import { styled, Typography } from "@mui/material"

const TableHeaderText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "0.75rem",
  [theme.breakpoints.up("md")]: {
    fontSize: "1rem"
  }
}))

export default TableHeaderText

